import {CommentDiscussionIcon, GitPullRequestIcon, IssueOpenedIcon, RepoIcon, StackIcon} from '@primer/octicons-react'

export const topLevelCategories = [
  {
    name: 'Extensions',
    icon: StackIcon,
    value: 'agents',
  },
  {
    name: 'Repositories',
    icon: RepoIcon,
    value: 'repositories',
  },
  {
    name: 'Discussions',
    icon: CommentDiscussionIcon,
    value: 'repositories:discussions',
  },
  {
    name: 'Issues',
    icon: IssueOpenedIcon,
    value: 'repositories:issues',
  },
  {
    name: 'Pull requests',
    icon: GitPullRequestIcon,
    value: 'repositories:pulls',
  },
] as const

export type AutocompleteCategory = (typeof topLevelCategories)[number]

export type CategoryValue = AutocompleteCategory['value']
